import {
  ArrowRight,
  CheckCircle,
  CurrencyInr,
  MapTrifold,
  Path,
  ShieldCheck,
  Truck
} from "@phosphor-icons/react";

const LOGISTICS_IMAGE = "/assets/loado-logistics-fleet.png";

export const LogisticsSection = () => {
  const benefits = [
    {
      icon: MapTrifold,
      title: "Live trip tracking",
      description: "Track your vehicle from pickup to drop with live movement updates."
    },
    {
      icon: CurrencyInr,
      title: "KM based pricing",
      description: "Book trips with distance-based pricing designed for clear fleet movement costs."
    },
    {
      icon: Path,
      title: "Local and inter-city",
      description: "Move goods within the city or between cities based on your delivery need."
    },
    {
      icon: ShieldCheck,
      title: "Verified fleet partners",
      description: "Choose from checked vehicle partners for personal, business, and material movement."
    }
  ];

  const scrollToVehicles = () => {
    const element = document.querySelector("#vehicles");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="logistics"
      data-testid="logistics-section"
      className="py-20 lg:py-32 bg-white relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0055FF] to-[#3B82F6]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2">
              <Truck size={20} weight="duotone" className="text-[#0055FF]" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0055FF]">
                On-Demand Fleet Booking
              </span>
            </div>

            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0F172A] mb-5">
                Book any fleet for goods, business, or material movement.
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Loado is an on-demand fleet booking service for anyone who needs
                to move goods. Send shop stock, household items, business loads,
                construction materials, equipment, or bulk cargo with the right
                vehicle for the trip.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              {benefits.map((benefit, index) => (
                <div
                  key={benefit.title}
                  data-testid={`logistics-benefit-${index}`}
                  className="group p-5 border border-slate-200 rounded-lg card-hover card-blue-accent"
                >
                  <div className="w-10 h-10 bg-[#0055FF]/10 flex items-center justify-center rounded-lg mb-4 group-hover:bg-[#0055FF] transition-colors">
                    <benefit.icon size={22} weight="duotone" className="text-[#0055FF] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-bold text-[#0F172A] mb-2">{benefit.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>

            <button
              data-testid="logistics-explore-fleet-btn"
              onClick={scrollToVehicles}
              className="group inline-flex items-center gap-2 px-6 py-3 bg-[#0055FF] text-white font-semibold rounded-lg btn-lift"
            >
              View Vehicle Categories
              <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          <div className="relative lg:pl-8">
            <div className="relative bg-[#F8FAFC] border border-slate-200 rounded-lg overflow-hidden">
              <img
                src={LOGISTICS_IMAGE}
                alt="Loado on-demand fleet booking"
                className="w-full h-auto object-contain"
                data-testid="logistics-image"
              />
            </div>

            <div className="flex flex-wrap gap-3 mt-6">
              {["KM based pricing", "Inter-city service", "Live tracking", "All load types"].map((feature) => (
                <div key={feature} className="flex items-center gap-2 px-4 py-2 bg-[#0055FF]/5 border border-[#0055FF]/20 rounded-lg">
                  <CheckCircle size={16} weight="fill" className="text-[#0055FF]" />
                  <span className="text-sm font-medium text-slate-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
